<div class="dashboard">
  <div class="masonry-view clearfix">
    <div class="masonry-grid-item">
      <div class="company-details">
        <div class="inner-wrapper">
          <div class="company-image">
            <img
              *ngIf="BusinessImage; else businessLogo"
              class="img-fluid image"
              src="{{ BusinessImage }}"
              alt=""
            />
            <ng-template #businessLogo>
              <img [src]="dashboardDefaultImage" class="img-fluid" alt="" />
            </ng-template>
          </div>
          <div class="company-content">
            <div *ngIf="BusinessName">
              <strong>{{ BusinessName }}</strong>
            </div>
            <div *ngIf="adminAddress">
              <strong>{{ adminAddress }}</strong>
            </div>
            <div *ngIf="zipCode">
              <p>{{ zipCode }}</p>
            </div>
            <div *ngIf="adminPostalAddress">
              <strong>{{ adminPostalAddress }}</strong>
            </div>
            <div *ngIf="Telephone">
              <p>{{ Telephone }}</p>
            </div>
            <div *ngIf="AboutBusiness">
              <p>
                <strong style="white-space: break-spaces">{{
                  AboutBusiness
                }}</strong>
              </p>
            </div>
            <div *ngIf="isPortal">
              <p>
                <strong style="white-space: break-spaces">{{
                  description
                }}</strong>
              </p>
            </div>
            <div *ngIf="HseGoals">
              <p>
                <strong>{{ HseGoals }} </strong>
              </p>
            </div>
            <div *ngIf="dashboardAdmin">
              <strong [innerHTML]="dashboardAdmin"></strong>
            </div>
          </div>
          <div class="default-list-nb">
            <div class="list-item" *ngIf="hseManager">
              <span style="padding-left: 0px">
                <strong translate>HSE_RESPONSIBLE</strong>
              </span>
              <span> {{ hseManager }} </span>
            </div>
            <div class="list-item" *ngIf="Envlight">
              <span style="padding-left: 0px">
                <strong translate>ENVIRONMENTAL_LIGHTHOUSE_RESPONSIBLE</strong>
              </span>
              <span> {{ Envlight }} </span>
            </div>
            <div class="list-item" *ngFor="let function of businessFunction">
              <span
                style="padding-left: 0px"
                *ngIf="function.IsTranslate; else functionName"
              >
                <strong> {{ function.Function | translate }} </strong>
              </span>
              <ng-template #functionName>
                <strong> {{ function.Function }} </strong>
              </ng-template>
              <span> {{ function.Employee }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && hasFollowupRights && hasActivitiesRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>ACTIVITIES</h4>
          <!-- Tells the user the box lists their own activities, not the whole business. -->
          <span class="wb-view-label" *ngIf="activityView === 'list'">
            {{ 'MY_ACTIVITIES' | translate }}
          </span>
          <!-- Says what the chart counts; the tooltip explains how deadlines from all years are grouped. -->
          <span
            class="wb-view-label"
            *ngIf="activityView === 'chart' && !isPortal && activities.length !== 0"
            pTooltip="{{ 'ACTIVITIES_CHART_DESCRIPTION' | translate }}"
            tooltipPosition="top"
          >
            {{ 'ACTIVITIES_CHART_LABEL' | translate }}
            <i class="pi pi-info-circle wb-view-label-info"></i>
          </span>
          <div class="widget-actions">
            <span *ngIf="isActivity">
              <a
                *ngIf="!isPortal && !isAdmin"
                href="javascript:void(0);"
                [routerLink]="['../follow-up/activities']"
                [queryParams]="{ prop: 'new', openDialog: true }"
                class="wa-btn text-success btn-link"
                pTooltip="{{ 'NEW_ACTIVITY' | translate }}"
                tooltipPosition="top"
              >
                <i class="icon ic-md icon-plus-2"></i>
              </a>
            </span>
            <!-- Switches the card between the activity chart and the user's own activities. -->
            <a
              *ngIf="canToggleOwnRecords && activities.length !== 0"
              href="javascript:void(0);"
              class="wa-btn"
              (click)="toggleActivityView()"
              pTooltip="{{ activityViewToggleLabelKey | translate }}"
              tooltipPosition="top"
            >
              <i class="pi" [ngClass]="activityViewToggleIcon"></i>
            </a>
            <a
              href="javascript:void(0);"
              [routerLink]="['../follow-up/activities']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>

        <!-- BUSINESS LEVEL ACTIVITIES -->

        <div
          *ngIf="!isPortal && !isAdmin && activities.length !== 0"
          class="wb-content"
          [class.wb-content--list]="activityView === 'list'"
        >
          <app-activities-business-widget
            *ngIf="activityView === 'chart'"
            [activities]="activities"
          >
          </app-activities-business-widget>

          <app-my-activities-widget
            *ngIf="activityView === 'list' && canToggleOwnRecords"
          >
          </app-my-activities-widget>
        </div>
        <!-- PORTAL LEVEL ACTIVITIES -->
        <div *ngIf="isPortal && activities.length !== 0" class="wb-content">
          <app-activities-portal-widget> </app-activities-portal-widget>
        </div>

        <div *ngIf="activities.length <= 0" class="wb-content">
          <div class="no-data">
            <span>
              <span class="icon ic-lg icon-041"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>

        <!-- Admin LEVEL ACTIVITIES -->
        <!-- DISABLED UNTIL FURTHER DEVELOPMENT -->
        <div *ngIf="isAdmin" class="wb-content">
          <div class="no-data">
            <span>
              <span class="icon ic-lg icon-041"></span>
              <span translate>FEATURE_DISABLED</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Portal-level BHT-samsvar overview requires Flexi on the portal. -->
    <div class="masonry-grid-item" *ngIf="isPortal && hasFlexi">
      <div class="widget-box widget-box--flexi-compliance">
        <div class="wb-title">
          <h4>{{ 'FLEXI_COMPLIANCE.PORTAL_WIDGET.TITLE' | translate }}</h4>
        </div>
        <div class="wb-content">
          <app-flexi-compliance-portal-widget></app-flexi-compliance-portal-widget>
        </div>
      </div>
    </div>

    <!-- Business-level BHT-samsvar pie chart — the business's own current
         OHS Compliance Review status. Shown to Editor / User on their own
         business (and to Admin / Portal acting in R-mode, whose roleId is
         editor there), only when the business has the Flexi module. -->
    <div class="masonry-grid-item" *ngIf="(isEditor || isUser) && hasFlexi">
      <div class="widget-box widget-box--flexi-compliance">
        <div class="wb-title">
          <h4>{{ 'FLEXI_COMPLIANCE.BUSINESS_WIDGET.TITLE' | translate }}</h4>
        </div>
        <div class="wb-content">
          <app-flexi-compliance-business-widget></app-flexi-compliance-business-widget>
        </div>
      </div>
    </div>

    <!-- Handlingsplan — outstanding BHT-samsvar commitments, worst first.
         Covers recurring and one-off action points, and surfaces the
         compliance markers (skipped cycles, shifted schedule, overdue) that
         nothing else in the product reveals. Renders a positive "all clear"
         state rather than hiding when there is nothing outstanding, so its
         silence cannot be mistaken for nothing being tracked.

         Gated on hasActionPointAccess, NOT on the (isEditor || isUser) test the
         score card uses: action points name a responsible person and record
         what they have not done, so a rank-and-file User only sees the card
         when they are the business's named OHS responsible. The BE answers
         that — the same rule guards the data endpoints, so this card can never
         show for someone the API would refuse. hasActionPointAccess already
         implies Flexi (the probe short-circuits without it). -->
    <div class="masonry-grid-item" *ngIf="!isAdmin && hasActionPointAccess">
      <div class="widget-box widget-box--flexi-compliance">
        <div class="wb-title">
          <h4>{{ 'FLEXI_COMPLIANCE.ACTION_POINTS_WIDGET.TITLE' | translate }}</h4>
          <div class="widget-actions">
            <a
              href="javascript:void(0);"
              [routerLink]="['../Flexi/action-points']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <app-flexi-compliance-action-points-widget></app-flexi-compliance-action-points-widget>
        </div>
      </div>
    </div>

    <div class="masonry-grid-item" *ngIf="!isAdmin && hasCalendarRights">
      <div class="widget-box">
        <full-calendar
          [options]="calendarOptions"
          (eventClick)="eventClick($event.detail)"
          class="custom-full-calendar"
        ></full-calendar>
      </div>
    </div>

    <div
      class="masonry-grid-item"
      *ngIf="hasFollowupRights && hasDeviationRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>DEVIATIONS</h4>
          <!-- Tells the user the box counts their own deviations, not the whole business. -->
          <span class="wb-view-label" *ngIf="deviationView === 'list'">
            {{ 'MY_DEVIATIONS' | translate }}
          </span>
          <div class="widget-actions">
            <span *ngIf="isDeviation">
              <a
                *ngIf="!isAdmin && !isPortal"
                href="javascript:void(0);"
                (click)="onNewDeviationClick()"
                class="wa-btn text-success btn-link"
                pTooltip="{{ 'NEW_DEVIATION' | translate }}"
                tooltipPosition="top"
              >
                <i class="icon ic-md icon-plus-2"></i>
              </a>
            </span>
            <!-- Switches the card between the deviation chart and the user's own deviations. -->
            <a
              *ngIf="canToggleOwnRecords && deviationCount.length > 0"
              href="javascript:void(0);"
              class="wa-btn"
              (click)="toggleDeviationView()"
              pTooltip="{{ deviationViewToggleLabelKey | translate }}"
              tooltipPosition="top"
            >
              <i class="pi" [ngClass]="deviationViewToggleIcon"></i>
            </a>
            <a
              href="javascript:void(0);"
              [routerLink]="['../follow-up/deviations']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div
          class="wb-content"
          [class.wb-content--list]="deviationView === 'list'"
        >
          <app-deviation-widget
            *ngIf="deviationView === 'chart' && deviationCount.length > 0"
            [deviationCount]="deviationCount"
          ></app-deviation-widget>

          <app-my-deviations-widget
            *ngIf="deviationView === 'list' && canToggleOwnRecords"
          ></app-my-deviations-widget>

          <div *ngIf="deviationCount.length <= 0 && !isAdmin" class="no-data">
            <span>
              <span class="icon ic-lg icon-041"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="masonry-grid-item" *ngIf="!isAdmin && hasFollowupRights && hasRiskRights">
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>RISK_ANALYSES</h4>
          <div class="widget-actions">
            <span *ngIf="isRiskAnalysis">
              <a
                *ngIf="!isPortal && !isAdmin"
                href="javascript:void(0);"
                [routerLink]="['../follow-up/risk-analysis/newrisk']"
                class="wa-btn text-success btn-link"
                pTooltip="{{ 'NEW_RISK_ADD' | translate }}"
                tooltipPosition="top"
              >
                <i class="icon ic-md icon-plus-2"></i>
              </a>
            </span>
            <a
              href="javascript:void(0);"
              [routerLink]="['../follow-up/risk-analysis']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <!-- Widget for business level -->
          <div *ngIf="!isAdmin && !isPortal">
            <app-risk-analysis-business-widget
              *ngIf="riskAnalysis.length > 0"
              [riskAnalysis]="riskAnalysis"
            ></app-risk-analysis-business-widget>
          </div>
          <!-- Widget for Portal level -->
          <div *ngIf="isPortal">
            <app-risk-analysis-portal-widget
              *ngIf="riskAnalysis.length > 0"
              [riskAnalysis]="riskAnalysis"
            >
            </app-risk-analysis-portal-widget>
          </div>
          <!-- Admin widget not yet implemented -->
          <div *ngIf="isAdmin" class="no-data">
            <span>
              <span class="icon ic-lg icon-041"></span>
              <span translate>FEATURE_DISABLED</span>
            </span>
          </div>
          <div *ngIf="riskAnalysis.length <= 0 && !isAdmin" class="no-data">
            <span>
              <span class="icon ic-lg icon-041"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && hasFollowupRights && hasMeasureRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>MEASURES</h4>
        </div>
        <div class="wb-content">
          <div class="default-list-nb" *ngIf="!(measures.length <= 0)">
            <div class="list-item">
              <span>
                <strong translate>NAME</strong>
              </span>
              <span>
                <strong translate>MEASURES</strong>
              </span>
            </div>
            <div class="list-item" *ngFor="let measure of measures">
              <span>{{ measure.Name }}:</span>
              <span>{{ measure.Measures }}</span>
            </div>
          </div>
          <div *ngIf="measures.length <= 0" class="no-data">
            <span>
              <span class="icon ic-lg icon-055"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && !isPortal && hasInternalNewsRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>INTERNAL_NEWS</h4>
          <div class="widget-actions">
            <a
              *ngIf="!isUser && !isGuest"
              href="javascript:void(0);"
              [routerLink]="['../news/create/', 0, 0]"
              class="wa-btn text-success btn-link"
              pTooltip="{{ 'ADD_NEWS' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-plus-2"></i>
            </a>
            <a
              href="javascript:void(0);"
              [routerLink]="['../news/list']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="default-list-nb">
            <div class="list-item" *ngFor="let news of internalNews">
              <span>
                <a
                  href="javascript:void(0);"
                  [routerLink]="['../news/create/', news.Id, 1]"
                >
                  <span translate>{{ news.Title }}</span>
                </a>
              </span>
            </div>
          </div>
          <div *ngIf="internalNews == null" class="no-data">
            <span>
              <span class="icon ic-lg icon-030"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="(isUser || isEditor || isAdmin || isPortal) && hasNewsRights"
    >
      <div class="widget-box widget-box--admin-news">
        <div class="wb-title">
          <h4>{{ adminNewsTitleKey | translate }}</h4>
          <div class="widget-actions">
            <a
              *ngIf="isAdmin && !isPortal"
              href="javascript:void(0);"
              [routerLink]="['../news/create/', 0, 0]"
              class="wa-btn btn-add btn-link"
              title="{{ 'ADD_NEWS' | translate }}"
            >
              <i class="icon ic-md icon-plus-2"></i>
            </a>
            <a
              *ngIf="isAdmin"
              href="javascript:void(0);"
              [routerLink]="['../news/list']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
            <a
              *ngIf="!isAdmin"
              href="javascript:void(0);"
              [routerLink]="['/app/admin/1/news/Adminlist']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="default-list-nb">
            <div class="list-item" *ngFor="let news of adminNews">
              <span>
                <a
                  *ngIf="canEditAdminNews; else adminNewsViewerLink"
                  href="javascript:void(0);"
                  [routerLink]="['../news/create/', news.Id, 1]"
                >
                  <span>{{ news.Title }}</span>
                </a>
                <ng-template #adminNewsViewerLink>
                  <a href="javascript:void(0);" (click)="openAdminNews(news)">
                    <span>{{ news.Title }}</span>
                  </a>
                </ng-template>
              </span>
            </div>
          </div>
        </div>
        <app-admin-news-viewer
          [news]="selectedAdminNews"
          (closed)="selectedAdminNews = null"
        ></app-admin-news-viewer>
      </div>
    </div>
    <div class="masonry-grid-item" *ngIf="!isAdmin && hasPortalNewsRights">
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>NEWS_PORTAL</h4>
          <div class="widget-actions">
            <a
              href="javascript:void(0);"
              [routerLink]="['../dashboard-ownpage/', 'Portal']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="wb-content">
            <div style="padding: 10px" [innerHTML]="portalNews"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="masonry-grid-item" *ngIf="hasAboutKubaRights">
      <div class="widget-box">
        <div class="wb-title">
          <!-- Brand-neutral for every application: the widget used to read
               "Om Kuba <app name>" ("Om Salutis", "Om Agil", ...) and only
               Salutis got the neutral wording. -->
          <h4>{{ "ABOUT_SYSTEM" | translate }}</h4>
          <div class="widget-actions">
            <a
              href="javascript:void(0);"
              [routerLink]="['../dashboard-ownpage/', 'Admin']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div
            style="padding: 10px; word-break: break-all"
            [innerHTML]="aboutKuba"
          ></div>
        </div>
      </div>
    </div>
    <!-- Recent logins: Business-->
    <div class="masonry-grid-item" *ngIf="hasLoggedHistory && !isAdmin">
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>LOGGED_HISTORY</h4>
          <div class="widget-actions">
            <a
              (click)="viewLogged = !viewLogged"
              class="wa-btn"
              href="javascript:void(0);"
            >
              <i
                [ngClass]="
                  viewLogged == false
                    ? 'icon ic-sm icon-bar-chart'
                    : 'icon ic-md icon-forward-button'
                "
              ></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="default-list-nb" *ngIf="loggedUser.length > 0">
            <div class="list-item">
              <span>
                <strong *ngIf="isPortal" translate>BUSINESS_NAME</strong>
                <strong *ngIf="isEditor || isUser" translate>USER_NAME</strong>
              </span>
              <span class="count-column">
                <strong> {{ dayBeforeYesterday | date: "dd-MMM" }}</strong>
              </span>
              <span class="count-column">
                <strong> {{ yesterday | date: "dd-MMM" }}</strong>
              </span>
              <span class="count-column">
                <strong>{{ today | date: "dd-MMM" }}</strong>
              </span>
            </div>
            <div class="list-item" *ngFor="let user of loggedUser">
              <span>{{ user.Business }}</span>
              <span class="count-column">{{
                user.DayBeforeYesterdayCount
              }}</span>
              <span class="count-column">{{ user.YesterdayCount }}</span>
              <span class="count-column">{{ user.TodayCount }}</span>
            </div>
          </div>
          <div *ngIf="loggedUser.length <= 0" class="no-data">
            <span>
              <span class="icon ic-lg icon-052"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent logins: Admin (And Portals in the future)-->
    <div class="masonry-grid-item" *ngIf="isAdmin">
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>LOGINS_LAST_30_DAYS</h4>
          <div class="widget-actions">
            <a
              (click)="viewLogged = !viewLogged"
              class="wa-btn"
              href="javascript:void(0);"
            >
              <i
                [ngClass]="
                  viewLogged == false
                    ? 'icon ic-sm icon-bar-chart'
                    : 'icon ic-md icon-forward-button'
                "
              ></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="default-list-nb" *ngIf="loggedInBusinesses.length > 0">
            <div class="list-item">
              <span>
                <strong translate>BUSINESS_NAME</strong>
              </span>
              <span>
                <strong translate>LOGIN_COUNT</strong>
              </span>
            </div>
            <div class="list-item" *ngFor="let business of loggedInBusinesses">
              <span>{{ business.Business }}</span>
              <span class="count-column">{{ business.LoginCount }}</span>
            </div>
          </div>
          <div *ngIf="loggedInBusinesses.length <= 0" class="no-data">
            <span>
              <span class="icon ic-lg icon-052"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="masonry-grid-item" *ngIf="!isAdmin && hasAppHistory">
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>APP_HISTORY</h4>
        </div>
        <div class="wb-content">
          <div class="no-data" *ngIf="!isAppLog">
            <span>
              <span class="icon ic-lg icon-052"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
          <div class="default-list-nb" *ngIf="isAppLog">
            <div class="list-item">
              <span>
                <strong translate>NAME</strong>
              </span>
              <span class="count-column">
                <strong> {{ dayBeforeYesterday | date: "dd-MMM" }}</strong>
              </span>
              <span class="count-column">
                <strong> {{ yesterday | date: "dd-MMM" }}</strong>
              </span>
              <span class="count-column">
                <strong>{{ today | date: "dd-MMM" }}</strong>
              </span>
            </div>
            <div class="list-item" *ngFor="let user of appLoggedUser">
              <span>{{ user.Business }}</span>
              <span class="count-column">{{
                user.DayBeforeYesterdayCount
              }}</span>
              <span class="count-column">{{ user.YesterdayCount }}</span>
              <span class="count-column">{{ user.TodayCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && hasLinksRights && hasDLinksRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>LINKS</h4>
          <div class="widget-actions">
            <a
              *ngIf="!isPortal"
              href="javascript:void(0);"
              [routerLink]="['../business/edit/' + businessId + '/links']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
            <a
              *ngIf="isPortal"
              href="javascript:void(0);"
              [routerLink]="['../portal-link']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <div class="default-list-nb" *ngIf="links">
            <div class="list-item" *ngFor="let link of links">
              <span>
                <a
                  href="javascript:void(0);"
                  target="_blank"
                  href="{{ link.Url }}"
                >
                  <span translate>{{ link.Title }}</span>
                </a>
              </span>
            </div>
          </div>
          <div *ngIf="!links" class="no-data">
            <span>
              <span class="icon ic-lg icon-030"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="isPortalBusiness && hasPortalLinksRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>PORTALLINKS</h4>
        </div>
        <div class="wb-content">
          <div class="default-list-nb" *ngIf="Portallinks">
            <div class="list-item" *ngFor="let link of Portallinks">
              <span>
                <a
                  href="javascript:void(0);"
                  target="_blank"
                  href="{{ link.Url }}"
                >
                  <span translate>{{ link.Title }}</span>
                </a>
              </span>
            </div>
          </div>
          <div *ngIf="!Portallinks" class="no-data">
            <span>
              <span class="icon ic-lg icon-030"></span>
              <span translate>NO_RECORDS_FOUND</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog meetings belong to a business, so the card is not shown at portal level. -->
    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && !isPortal && hasDialogMeetingsRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>EMPLOYEE_DIALOG_MEETINGS</h4>
          <div class="widget-actions">
            <a
              href="javascript:void(0);"
              [routerLink]="['../employee/appraisals']"
              [queryParams]="{ tab: dialogMeetingTab }"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <app-dialog-meetings-widget
            [businessId]="businessId"
            (scopeTabChanged)="onDialogMeetingScopeTabChange($event)"
          ></app-dialog-meetings-widget>
        </div>
      </div>
    </div>
    <div
      class="masonry-grid-item"
      *ngIf="!isAdmin && !isPortal && businessId > 0 && hasSafetyDataSheetsRights"
    >
      <div class="widget-box">
        <div class="wb-title">
          <h4 translate>CHEMICALS</h4>
          <div class="widget-actions">
            <!-- Switches the card between the risk graph and the product list. -->
            <a
              href="javascript:void(0);"
              class="wa-btn"
              (click)="chemicalsWidget.toggleView()"
              pTooltip="{{ chemicalsWidget.viewToggleLabelKey | translate }}"
              tooltipPosition="top"
            >
              <i class="pi" [ngClass]="chemicalsWidget.viewToggleIcon"></i>
            </a>
            <a
              href="javascript:void(0);"
              [routerLink]="['../safety-data-sheets/list']"
              class="wa-btn"
              pTooltip="{{ 'VIEW_ALL' | translate }}"
              tooltipPosition="top"
            >
              <i class="icon ic-md icon-forward-button"></i>
            </a>
          </div>
        </div>
        <div class="wb-content">
          <app-chemicals-sds-widget
            #chemicalsWidget
            [businessId]="businessId"
          ></app-chemicals-sds-widget>
        </div>
      </div>
    </div>
  </div>
</div>
